module.exports = __webpack_public_path__ + "img/login.7809c988.png";